import { render, staticRenderFns } from "./adminModal.vue?vue&type=template&id=24c77628&scoped=true&"
import script from "./adminModal.vue?vue&type=script&lang=js&"
export * from "./adminModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24c77628",
  null
  
)

export default component.exports